import { axios } from '@/services/axios';

export const getResourceAccounts = async (currentCompany) => {
    const res = await axios.get(`/ResourceAccounts/${currentCompany}`);
    return res.data;
};
